export enum RoomState {
  Connected = 'connected',
  Reconencting = 'reconnecting',
  Disconnected = 'disconnected',
}
